export * from './nav-dropdown.directive';



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/directives/nav-dropdown/index.ts